export const MAIN = '/main';
export const CATEGORY = '/category/:cg';
export const DETAIL = '/detail';
export const MYPAGE = '/mypage';
